<template>
  <div class="login">
    <div class="login-form">
      <div class="header">
        <p class="is-title">
          {{ isSubmitted ? "Пароль успешно изменен" : "Введите новый пароль" }}
        </p>
      </div>
      <template v-if="!isSubmitted">
        <v-field
          v-model="password"
          type="password"
          is-full-width
          placeholder="Пароль"
          help-text="Пароль должен состоять из восьми или более символов"
          :is-error="
            !errors.checkErrorIsFixed('new_password', password.length >= 8)
          "
          :error-text="errors.getErrorByName('new_password')"
        />
        <v-field
          v-model="repeatPassword"
          type="password"
          is-full-width
          :is-error="!repeatPasswordIsValid"
          placeholder="Подтверждение пароля"
        />
        <v-button
          text="Сохранить"
          color="blue"
          fluid
          size="md"
          :disabled="!passwordIsValid || !repeatPasswordIsValid"
          @click="resetPassword"
        />
      </template>
    </div>
  </div>
</template>

<script>
import VField from "../components/VField";
import VButton from "../components/VButton";
import showMessageMixin from "@/mixins/showMessageMixin";
import passwordValidationMixin from "../mixins/passwordValidationMixin";
import { validateField } from "@/utilities";
import { mapGetters } from "vuex";

export default {
  name: "ResetPassword",
  components: {
    VField,
    VButton
  },
  mixins: [showMessageMixin, passwordValidationMixin],
  data() {
    return {
      password: "",
      repeatPassword: "",
      isSubmitted: false
    };
  },
  computed: {
    ...mapGetters({
      errors: "authorization/getErrors"
    }),
    config() {
      return {
        new_password: this.password,
        email: this.$route.query.email,
        token: this.$route.query.token
      };
    }
    // passwordIsValid() {
    //   return validateField("password", this.password);
    // },
    // repeatPasswordIsValid() {
    //   return this.password === this.repeatPassword;
    // }
  },
  methods: {
    async resetPassword() {
      let res = await this.$store.dispatch(
        "authorization/recoverPassword",
        this.config
      );
      if (res) {
        this.isSubmitted = true;
        setTimeout(() => this.$router.push("/"), 5000);
      }
    }
  }
};
</script>
